import React, { useState } from 'react';
import { Check, X, ChevronDown } from 'lucide-react';
import { GenreAndStyleDropdown } from './components/GenreAndStyleDropdown';
import { showToast } from '../../../../helper/ShowToast';

export default function MasteredSection({ onNextClick, isLoading }) {
    const [isMastered, setIsMastered] = useState(null);
    const [selectedOption, setSelectedOption] = useState('');

    const handleSelectedOption = (option) => {
        setSelectedOption(option)
    }

    const handleNextClick = () => {
        // Validation
        if (isMastered === null && !selectedOption) {
            showToast('error', 'Please answer both questions before proceeding');
            return;
        }

        if (isMastered === null) {
            showToast('error', 'Please select whether your track is mastered');
            return;
        }

        if (!selectedOption) {
            showToast('error', 'Please select a genre/style that describes your sound');
            return;
        }

        // All validations passed
        onNextClick({
            isMastered: isMastered,
            selectedGenre: selectedOption
        });
    }

    const isFormComplete = isMastered !== null && selectedOption;

    return (
        <div className="rounded-2xl flex items-center justify-center font-jakarta bg-theme_clr1 p-6">
            <div className="w-full max-w-4xl space-y-8">
                {/* Question 1 */}
                <div className="text-center space-y-4">
                    <h1 className="text-[24px] font-normal text-theme_clr2">
                        Is your track mastered?
                    </h1>
                    <p className="text-white/75 text-[16px] font-normal">
                        A mastered track is professionally polished, optimized for loudness, and<br />
                        ready for release.
                    </p>
                </div>

                {/* Yes/No Buttons */}
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                    <button
                        onClick={() => setIsMastered(true)}
                        className={`flex items-center justify-center gap-3 p-6 rounded-2xl text-xl font-medium transition-all ${isMastered === true
                                ? 'bg-white text-theme_clr2 border-4 border-[#FA6138]'
                                : 'bg-white text-theme_clr1 shadow-lg border-4 border-transparent'
                            }`}
                    >
                        <Check size={28} className={`${isMastered === true ? 'text-theme_clr2' : 'text-theme_clr1'}`} />
                        Yes
                    </button>

                    <button
                        onClick={() => setIsMastered(false)}
                        className={`flex items-center justify-center gap-3 p-6 rounded-2xl text-xl font-medium transition-all ${isMastered === false
                                ? 'bg-white text-theme_clr2 border-4 border-[#FA6138]'
                                : 'bg-white text-theme_clr1 shadow-lg border-4 border-transparent'
                            }`}
                    >
                        <X size={28} className={`${isMastered === false ? 'text-theme_clr2' : 'text-theme_clr1'}`} />
                        No
                    </button>
                </div>

                {/* Question 2 */}
                <div className="text-center space-y-6 pt-8">
                    <h2 className="text-[24px] font-normal text-theme_clr2">
                        What most clearly describes your sound?
                    </h2>

                    <GenreAndStyleDropdown
                        backgroundColor={'bg-theme_clr2'}
                        getSelectedOption={handleSelectedOption}
                    />

                    <div className="pt-4">
                        <button
                            onClick={handleNextClick}
                            disabled={!isFormComplete || isLoading}
                            className={`px-12 py-4 rounded-2xl text-xl font-medium transition-all shadow-lg flex items-center justify-center gap-3 mx-auto w-96 ${isFormComplete
                                    ? 'bg-theme_clr2 text-white'
                                    : 'bg-transparent border-2 border-theme_clr2 text-theme_clr2 cursor-not-allowed opacity-60'
                                }`}
                        >
                            {isLoading ? (
                                <p>Please wait...</p>
                                // <svg
                                //     className="animate-spin h-6 w-6 text-white"
                                //     xmlns="http://www.w3.org/2000/svg"
                                //     fill="none"
                                //     viewBox="0 0 24 24"
                                // >
                                //     <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" />
                                //     <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z" />
                                // </svg>
                            ) : (
                                <>
                                    <Check size={24} />
                                    Next
                                </>
                            )}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
}